var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Instant } from '@js-joda/core';
import { useFetchPromise } from '@rad/hooks';
import { withDone } from '@rad/utility/http';
import { SITE, SITE_IS_AUTO, NEWLINE } from '../../utility/constants';
import { requireToken, navigate } from '../../utility/general';
import { getJson, postObjectJson } from '../../utility/request';
import { parseInstant, parseInstantN } from '../../utility/parsers';
import { fetchMerchant } from '../../http/merchants';
import { addJob, updateJob, deleteJob, fetchInvoice, fetchClient, fetchPerformers, resolveDefaultPerformerId } from '../../http/invoices';
import { getConnectorPartsTech } from '../../http/connectors';
import Button from '../components/button';
import CLoading from '../components/loading';
import CModal from '../components/modal';
import InvoiceCreate from './invoice-create';
import InvoiceEdit, { defaultUnitsForKind } from './invoice-edit';
const blankForms = () => ({
    'create': {
        'is_dual_pricing': false,
        'disable_discount': false,
        'show_part_numbers': false,
        'on_account': false,
        'due_date': null,
        'odometerin': null,
        'performer': null,
        'notes_intake': [],
        'notes_intake_new': [],
        'notes_fulfillment_new': [],
        'notes_feedback_new': [],
        'client_id': null,
        'client_firstname': '',
        'client_lastname': '',
        'client_businessname': '',
        'client_no_address': false,
        'client_tax_exempt': false,
        'client_address': '',
        'client_address2': '',
        'client_city': '',
        'client_state': null,
        'client_zip': '',
        'client_contacts': [],
        'client_notes': [],
        'client_notes_new': [],
        'vehicle_id': null,
        'vehicle_description': '',
        'vehicle_vin': '',
        'vehicle_tag': '',
        'vehicle_notes': [],
        'vehicle_notes_new': [],
    },
    'edit': {
        'active_job': null, // TODO: unsafe
        'is_dual_pricing': false,
        'disable_discount': false,
        'show_part_numbers': false,
        'on_account': false,
        'due_date': null,
        'odometerin': null,
        'odometerout': null,
        'performer': null,
        'jobs': [{
                'id': '',
                'title_raw': '',
                'title_display': 'Job 1',
                'optional': false,
                'created': Instant.now(),
                'client_approved': null,
                'client_signature': null,
                'client_visible': true,
                'superseded_by_invoice_id': null,
                'notes_intake': [],
                'notes_intake_new': [],
                'notes_fulfillment': [],
                'notes_fulfillment_new': [],
                'notes_feedback': [],
                'notes_feedback_new': [],
            }],
        'items': [],
        'vehicle_notes': [],
        'vehicle_notes_new': [],
    },
});
export default (props) => {
    var _a, _b, _c;
    const token = requireToken('merchant');
    const [raw, setRaw] = React.useState({ 'merchant': null, 'invoice': null, 'partstech': undefined, 'options': null });
    const [performers, reloadPerformers] = useFetchPromise(fetchPerformers(props.merchantId));
    const [client, setClient] = React.useState(null);
    const [vehicle, setVehicle] = React.useState(null);
    const [stateForms, setForms] = React.useState(() => blankForms());
    const [stateState, setState] = React.useState({
        'changes': false,
        'submitting': null,
        'confirming': { 'submitUnordered': null },
        'error': null,
        'editing': {},
    });
    const [modals, setModals] = React.useState({ 'openPartsTech': null });
    const [modalCashDiscountHelp, setModalCashDiscountHelp] = React.useState(false);
    const [modalSinglePriceHelp, setModalSinglePriceHelp] = React.useState(false);
    const [paidInvoiceGate, setPaidInvoiceGate] = React.useState(null);
    const cashDiscountImage = SITE_IS_AUTO ? '/assets/img/cash-discount-repair.png' : '/assets/img/cash-discount-general.png';
    const singlePriceImage = SITE_IS_AUTO ? '/assets/img/single-pricing-repair.png' : '/assets/img/single-pricing-general.png';
    React.useEffect(() => {
        if (props.invoiceId && stateForms.edit.active_job) {
            sessionStorage.setItem(`activeJob:${props.invoiceId}`, stateForms.edit.active_job.id);
        }
    }, [stateForms.edit.active_job, props.invoiceId]);
    React.useEffect(() => {
        if (props.invoiceId)
            return;
        if (!performers)
            return;
        if (!raw.merchant)
            return;
        const list = performers();
        if (!list.length)
            return;
        const resolved = resolveDefaultPerformerId(list);
        if (resolved === null)
            return;
        setForms((forms) => forms.create.performer !== null
            ? forms
            : Object.assign(Object.assign({}, forms), { 'create': Object.assign(Object.assign({}, forms.create), { 'performer': resolved }) }));
    }, [performers, raw.merchant, props.invoiceId]);
    const setChanged = () => {
        setState((s) => (Object.assign(Object.assign({}, s), { 'changes': true })));
        sessionStorage.setItem('unsaved', 'true');
    };
    const setSaved = () => {
        setState((s) => (Object.assign(Object.assign({}, s), { 'changes': false })));
        sessionStorage.removeItem('unsaved');
    };
    const initialize = () => __awaiter(void 0, void 0, void 0, function* () {
        setSaved();
        setState((s) => (Object.assign(Object.assign({}, s), { 'error': null })));
        const [merchant, partstech, options, invoice, client] = yield Promise.all([
            withDone(fetchMerchant(props.merchantId))(),
            getConnectorPartsTech(props.merchantId),
            getJson(`/merchants/${props.merchantId}/invoices/options`),
            props.invoiceId ? withDone(fetchInvoice(props.merchantId, props.invoiceId))() : Promise.resolve(null),
            props.clientId ? withDone(fetchClient(props.clientId))() : Promise.resolve(null),
        ]);
        if (!!invoice) {
            // Closed invoices with payments stay off-limits: once the customer has
            // paid or partially paid, the record is a bill and can't be amended
            // through this screen. Open ROs with deposits remain editable so the
            // Change Order flow can authorize new work.
            if (invoice.classification === 'invoice-paid' || invoice.classification === 'invoice-semipaid') {
                setPaidInvoiceGate({ 'redirect': `#/invoices/${props.merchantId}/${invoice.id}` });
                return;
            }
            const savedJob = sessionStorage.getItem(`activeJob:${invoice.id}`);
            setClient(invoice.client || null);
            setVehicle(invoice.vehicle || null);
            setForms((forms) => {
                var _a, _b, _c;
                return (Object.assign(Object.assign({}, forms), { 'edit': {
                        // ...forms.edit,
                        'active_job': (_a = invoice.jobs.find((j) => j.id === savedJob)) !== null && _a !== void 0 ? _a : invoice.jobs[0],
                        'is_dual_pricing': invoice.is_dual_pricing,
                        'disable_discount': invoice.disable_discount,
                        'show_part_numbers': invoice.show_part_numbers,
                        'on_account': invoice.on_account,
                        'due_date': ((_b = invoice.due_date) === null || _b === void 0 ? void 0 : _b.toString()) || null,
                        'performer': ((_c = invoice.performer) === null || _c === void 0 ? void 0 : _c.id) || null,
                        'odometerin': invoice.odometerin,
                        'odometerout': invoice.odometerout,
                        'jobs': invoice.jobs.map((x) => (Object.assign(Object.assign({}, x), { 'notes_intake_new': [], 'notes_feedback_new': [], 'notes_fulfillment_new': [] }))),
                        'items': invoice.items.map((x) => (Object.assign(Object.assign({}, x), { 'units': x.units || defaultUnitsForKind(x.kind), 'select': x.kind !== 'fee' }))),
                        'vehicle_notes': invoice.vehicle.notes,
                        'vehicle_notes_new': [],
                    } }));
            });
        }
        else {
            setClient(client);
            setVehicle(null);
            setForms((forms) => (Object.assign(Object.assign({}, forms), { 'create': {
                    'odometerin': null,
                    'disable_discount': merchant.invoice_default_pricing === 'no-discount',
                    'is_dual_pricing': merchant.invoice_default_pricing === 'dual',
                    'show_part_numbers': false,
                    'on_account': false,
                    'due_date': null,
                    'performer': null,
                    'jobs': [],
                    'notes_intake': [],
                    'notes_intake_new': [],
                    'notes_fulfillment_new': [],
                    'notes_feedback_new': [],
                    // CLIENT
                    'client_id': (client === null || client === void 0 ? void 0 : client.id) || null,
                    'client_firstname': (client === null || client === void 0 ? void 0 : client.firstname) || '',
                    'client_lastname': (client === null || client === void 0 ? void 0 : client.lastname) || '',
                    'client_businessname': (client === null || client === void 0 ? void 0 : client.businessname) || '',
                    'client_no_address': !!(client === null || client === void 0 ? void 0 : client.no_address),
                    'client_tax_exempt': !!(client === null || client === void 0 ? void 0 : client.tax_exempt),
                    'client_address': (client === null || client === void 0 ? void 0 : client.address.split(NEWLINE)[0]) || '',
                    'client_address2': (client === null || client === void 0 ? void 0 : client.address.split(NEWLINE)[1]) || '',
                    'client_city': (client === null || client === void 0 ? void 0 : client.city) || '',
                    'client_state': (client === null || client === void 0 ? void 0 : client.state) || null,
                    'client_zip': (client === null || client === void 0 ? void 0 : client.zip) || '',
                    'client_contacts': (client === null || client === void 0 ? void 0 : client.contacts) || [],
                    'client_notes': (client === null || client === void 0 ? void 0 : client.notes) || [],
                    'client_notes_new': [],
                    // VEHICLE
                    'vehicle_id': null,
                    'vehicle_description': '',
                    'vehicle_vin': '',
                    'vehicle_tag': '',
                    'vehicle_notes': [],
                    'vehicle_notes_new': [],
                } })));
        }
        setRaw({ 'merchant': merchant, 'invoice': invoice, 'partstech': partstech, 'options': options });
    });
    React.useEffect(() => {
        reloadPerformers();
    }, [props.merchantId]);
    React.useEffect(() => {
        initialize();
    }, [props.invoiceId, props.merchantId]);
    React.useEffect(() => {
        if (!props.invoiceId)
            return;
        if (!stateForms.edit.active_job)
            return;
        const [hash, query = ''] = window.location.hash.split('?');
        const parameters = new URLSearchParams(query);
        if (parameters.get('openPartsTech') !== '1')
            return;
        parameters.delete('openPartsTech');
        const remaining = parameters.toString();
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}${remaining ? `?${remaining}` : ''}`);
        openPartsTech();
    }, [stateForms.edit.active_job, props.invoiceId]);
    const confirmChanges = (action) => __awaiter(void 0, void 0, void 0, function* () {
        if (!stateState.changes) {
            yield action();
            return;
        }
        yield new Promise((resolve) => {
            const modal = {
                'save': true,
                'error': null,
                'cancel': () => resolve(),
                'submit': (done) => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        if (modal.save) {
                            yield invoiceSave(false, false);
                            if (stateState.error) {
                                modal.error = stateState.error;
                                setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': Object.assign({}, modal) })));
                                done();
                                return;
                            }
                        }
                        yield action();
                        setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': null })));
                        resolve();
                    }
                    finally {
                        done();
                    }
                }),
            };
            setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': modal })));
        });
    });
    const openPartsTech = () => __awaiter(void 0, void 0, void 0, function* () {
        yield confirmChanges(() => __awaiter(void 0, void 0, void 0, function* () {
            if (!props.invoiceId) {
                alert('Save invoice first before opening PartsTech.');
                return;
            }
            const result = yield postObjectJson(`/parts-tech/open/${props.merchantId}/${props.invoiceId}`, { 'redirect': window.location.href, 'job_id': stateForms.edit.active_job.id });
            const el = document.createElement('a');
            el.href = result.redirect_url;
            el.click();
        }));
    });
    const submitPartsTech = () => __awaiter(void 0, void 0, void 0, function* () {
        yield confirmChanges(() => __awaiter(void 0, void 0, void 0, function* () {
            const activeJob = stateForms.edit.active_job;
            const eligibleItems = stateForms.edit.items.filter((x) => !!x.id && x.source === 'partstech' && !x.status && x.kind === 'parts' && x.job_id === activeJob.id);
            setState((s) => (Object.assign(Object.assign({}, s), { 'confirming': Object.assign(Object.assign({}, s.confirming), { 'submitUnordered': {
                        'items': eligibleItems,
                        'onSubmit': (itemIds, finish) => __awaiter(void 0, void 0, void 0, function* () {
                            yield postObjectJson(`/parts-tech/cart/${props.merchantId}/${props.invoiceId}/submit`, { 'job_id': activeJob.id, 'item_ids': itemIds });
                            yield initialize();
                            finish();
                            setState((x) => (Object.assign(Object.assign({}, x), { 'confirming': Object.assign(Object.assign({}, x.confirming), { 'submitUnordered': null }) })));
                        }),
                    } }) })));
        }));
    });
    const invoiceSave = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (redirect = true, reload = true) {
        try {
            setState((s) => (Object.assign(Object.assign({}, s), { 'submitting': { 'redirect': redirect, 'started': true }, 'error': null })));
            yield postObjectJson(!!raw.invoice
                ? `/merchants/${props.merchantId}/invoices/save-${SITE}${raw.invoice.classification === 'invoice' ? '-converted' : ''}/${props.invoiceId}`
                : `/merchants/${props.merchantId}/invoices/save-${SITE}`, !!raw.invoice ? Object.assign(Object.assign({}, stateForms.edit), { 'items': stateForms.edit.items.map((x) => { var _a, _b; return (Object.assign(Object.assign(Object.assign({}, x), { 'notes_new': (_a = x.notes_new) !== null && _a !== void 0 ? _a : [], 'notes_deleted': (_b = x.notes_deleted) !== null && _b !== void 0 ? _b : [] }), (x.id && x.id.startsWith('_') ? { 'id': null } : {}))); }), 'jobs': stateForms.edit.jobs.map((x) => (Object.assign(Object.assign({}, x), { 'title': x.title_raw }))) }) : Object.assign({}, stateForms.create), {
                'success': (data) => {
                    setSaved();
                    if (!raw.invoice) {
                        if (redirect)
                            navigate(`#/invoices/${data.merchant_id}/${data.id}/edit`);
                    }
                    else if (redirect) {
                        navigate(`#/invoices/${data.merchant_id}/${data.id}`);
                    }
                    else if (reload) {
                        window.location.reload();
                    }
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () {
                    const errs = yield res.json();
                    setState((s) => (Object.assign(Object.assign({}, s), { 'error': errs })));
                }),
            });
        }
        finally {
            setState((s) => (Object.assign(Object.assign({}, s), { 'submitting': null })));
        }
    });
    const errorObject = React.useMemo(() => Object.fromEntries((stateState.error || []).map((x) => [x.field, x.message])), [stateState.error]);
    const addNewJob = (invoiceId) => __awaiter(void 0, void 0, void 0, function* () {
        const jobDTO = yield addJob(props.merchantId, invoiceId);
        const job = Object.assign(Object.assign({}, jobDTO), { 'title_raw': jobDTO.title, 'title_display': jobDTO.title || `Job ${stateForms.edit.jobs.length + 1}`, 'created': parseInstant(jobDTO.created), 'client_approved': parseInstantN(jobDTO.client_approved), 'superseded_by_invoice_id': jobDTO.superseded_by_invoice_id, 'client_visible': true, 'notes_intake_new': [], 'notes_fulfillment_new': [], 'notes_feedback_new': [] });
        setForms((s) => (Object.assign(Object.assign({}, s), { 'edit': Object.assign(Object.assign({}, s.edit), { 'activeJob': job, 'jobs': [...s.edit.jobs, job] }) }))); // TODO: non-declarative, but reloading loses unsaved state
        setState((s) => (Object.assign(Object.assign({}, s), { 'editing': Object.assign(Object.assign({}, s.editing), { [jobDTO.id]: { 'title': jobDTO.title, 'optional': jobDTO.optional } }) })));
    });
    const updateJobCall = (invoiceId, jobId, patch) => __awaiter(void 0, void 0, void 0, function* () {
        yield updateJob(props.merchantId, invoiceId, jobId, patch);
    });
    const deleteJobCall = (invoiceId, jobId) => __awaiter(void 0, void 0, void 0, function* () {
        yield deleteJob(props.merchantId, invoiceId, jobId);
        yield initialize();
    });
    return _jsxs(_Fragment, { children: [_jsx(CModal, { visible: !!modals.openPartsTech, title: "Unsaved Changes", onClose: () => { var _a; (_a = modals.openPartsTech) === null || _a === void 0 ? void 0 : _a.cancel(); setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': null }))); }, onSubmit: (_a = modals.openPartsTech) === null || _a === void 0 ? void 0 : _a.submit, nofooter: !!((_b = modals.openPartsTech) === null || _b === void 0 ? void 0 : _b.error), footer: (loading) => {
                    var _a, _b;
                    return _jsxs(_Fragment, { children: [_jsx(Button, { color: "secondary", onClick: () => { var _a; (_a = modals.openPartsTech) === null || _a === void 0 ? void 0 : _a.cancel(); setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': null }))); }, disabled: loading, children: "Cancel" }), _jsx(Button, { submit: true, color: "danger", onClick: () => modals.openPartsTech && setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': Object.assign(Object.assign({}, m.openPartsTech), { 'save': false }) }))), disabled: loading, children: loading && !((_a = modals.openPartsTech) === null || _a === void 0 ? void 0 : _a.save) ? 'Opening...' : 'Continue Without Saving' }), _jsx(Button, { submit: true, color: "primary", onClick: () => modals.openPartsTech && setModals((m) => (Object.assign(Object.assign({}, m), { 'openPartsTech': Object.assign(Object.assign({}, m.openPartsTech), { 'save': true }) }))), disabled: loading, children: loading && ((_b = modals.openPartsTech) === null || _b === void 0 ? void 0 : _b.save) ? 'Saving...' : 'Save and Continue' })] });
                }, children: !!((_c = modals.openPartsTech) === null || _c === void 0 ? void 0 : _c.error) ? _jsx("div", { className: "alert alert-danger mb-2", children: "Failed to save - please check the form for errors." }) : _jsx(_Fragment, { children: "Unsaved changes will be lost." }) }), _jsx(SubmitUnorderedDialog, { state: stateState.confirming.submitUnordered, onClose: () => setState((s) => (Object.assign(Object.assign({}, s), { 'confirming': Object.assign(Object.assign({}, s.confirming), { 'submitUnordered': null }) }))) }), _jsx(CModal, { visible: modalCashDiscountHelp, title: "Cash Discount Comparison: Enabled vs Disabled", onClose: () => setModalCashDiscountHelp(false), nofooter: true, xl: true, children: _jsx("div", { className: "text-center", children: _jsx("img", { src: cashDiscountImage, alt: "Cash Discount Example", className: "img-fluid", style: { 'maxWidth': '100%', 'height': 'auto' } }) }) }), _jsx(CModal, { visible: modalSinglePriceHelp, title: "Single-Price Comparison: Single Pricing vs Dual Pricing", onClose: () => setModalSinglePriceHelp(false), nofooter: true, xl: true, children: _jsx("div", { className: "text-center", children: _jsx("img", { src: singlePriceImage, alt: "Single-Price Example", className: "img-fluid", style: { 'maxWidth': '100%', 'height': 'auto' } }) }) }), _jsx(CModal, { visible: !!paidInvoiceGate, title: "Invoice closed", onClose: () => {
                    const dest = paidInvoiceGate === null || paidInvoiceGate === void 0 ? void 0 : paidInvoiceGate.redirect;
                    setPaidInvoiceGate(null);
                    if (dest)
                        navigate(dest);
                }, footer: () => _jsx(Button, { color: "primary", onClick: () => {
                        const dest = paidInvoiceGate === null || paidInvoiceGate === void 0 ? void 0 : paidInvoiceGate.redirect;
                        setPaidInvoiceGate(null);
                        if (dest)
                            navigate(dest);
                    }, children: "OK" }), children: "Cannot edit an invoice that has payment applied." }), _jsx(CLoading, { dependency: !!props.invoiceId && !raw.invoice ? undefined : raw.invoice, children: (invoice) => _jsxs(_Fragment, { children: [!invoice && _jsx(InvoiceCreate, { ctx: {
                                'form': stateForms.create,
                                'state': stateState,
                                'raw': raw,
                                'client': client,
                                'vehicle': vehicle,
                                'performers': performers,
                                'errorObject': errorObject,
                                'setState': (f) => setState((s) => (Object.assign(Object.assign({}, s), f(s)))),
                                'setForm': (f) => setForms((forms) => (Object.assign(Object.assign({}, forms), { 'create': f(forms.create) }))),
                                'setClient': setClient,
                                'setVehicle': setVehicle,
                                'setChanged': setChanged,
                                'setModalCashDiscountHelp': setModalCashDiscountHelp,
                                'setModalSinglePriceHelp': setModalSinglePriceHelp,
                                'invoiceSave': invoiceSave,
                            } }), !!invoice && _jsx(InvoiceEdit, { invoice: invoice, ctx: {
                                'form': stateForms.edit,
                                'state': stateState,
                                'raw': raw,
                                'performers': performers,
                                'errorObject': errorObject,
                                'setState': (f) => setState((s) => (Object.assign(Object.assign({}, s), f(s)))),
                                'setForm': (f) => setForms((forms) => (Object.assign(Object.assign({}, forms), { 'edit': f(forms.edit) }))),
                                'setChanged': setChanged,
                                'addNewJob': addNewJob,
                                'updateJob': updateJobCall,
                                'deleteJob': deleteJobCall,
                                'openPartsTech': openPartsTech,
                                'submitPartsTech': submitPartsTech,
                                'invoiceSave': invoiceSave,
                            } })] }) })] });
};
const SubmitUnorderedDialog = (props) => {
    var _a, _b;
    const [selected, setSelected] = React.useState(new Set());
    const items = (_b = (_a = props.state) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
    React.useEffect(() => {
        if (!!props.state)
            setSelected(new Set(props.state.items.map((x) => x.id)));
    }, [props.state]);
    const toggle = (id) => setSelected((s) => {
        const next = new Set(s);
        if (next.has(id))
            next.delete(id);
        else
            next.add(id);
        return next;
    });
    const allSelected = items.length > 0 && items.every((x) => selected.has(x.id));
    return _jsxs(CModal, { visible: props.state, title: "Submit Unordered Items", action: "Submit", onClose: props.onClose, disabled: selected.size === 0, onSubmit: (finish, s) => s.onSubmit(Array.from(selected), finish), children: [_jsx("p", { className: "mb-2", children: "Select the PartsTech items to order now. Unselected items stay on the invoice and can be ordered later. This cannot be undone." }), _jsxs("table", { className: "table table-sm table-striped mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { 'width': '1%' }, children: _jsx("input", { className: "form-check-input", type: "checkbox", checked: allSelected, onChange: () => setSelected(allSelected ? new Set() : new Set(items.map((x) => x.id))), "aria-label": "Select all" }) }), _jsx("th", { style: { 'width': '15%' }, children: "Qty" }), _jsx("th", { children: "Description" }), _jsx("th", { style: { 'width': '15%' }, className: "text-end", children: "Rate" })] }) }), _jsx("tbody", { children: items.map((x) => {
                            var _a;
                            return _jsxs("tr", { children: [_jsx("td", { children: _jsx("input", { className: "form-check-input", type: "checkbox", checked: selected.has(x.id), onChange: () => toggle(x.id), "aria-label": `Select ${x.description || 'item'}` }) }), _jsx("td", { children: x.quantity }), _jsx("td", { children: x.description }), _jsxs("td", { className: "text-end", children: ["$", ((_a = x.rate) !== null && _a !== void 0 ? _a : 0).toFixed(2)] })] }, x.id);
                        }) })] })] });
};
